import { useTranslation } from 'react-i18next';
import { Button, Stack, Typography } from '@mui/material';
import { StepBox } from '@/components/layout/step-box';
import { MySvgIcon } from '@/components/ui/svg-icon';
import { Flow } from '@/constants/flow';
import { useFlow } from '@/hooks/use-flow';

export const ExceptionExpiredCode: React.FC<{ type: 'reset' | 'recovery' | 'register' }> = ({ type }) => {
  const { t } = useTranslation();
  const { setFlow } = useFlow();
  const mapper = {
    reset: {
      // backFlow: Flow.RESET_PASSWORD_STEP_INPUT_PASSWORD,
      toFlow: Flow.RESET_PASSWORD_STEP_INPUT_CODE,
    },
    recovery: {
      // backFlow: Flow.RECOVERY_STEP_INPUT_PASSWORD,
      toFlow: Flow.RECOVERY_STEP_INPUT_CODE,
    },
    register: {
      // backFlow: Flow.REGISTER_STEP_INPUT_PASSWORD,
      toFlow: Flow.REGISTER_STEP_INPUT_CODE,
    },
  };

  const { toFlow } = mapper[type];
  return (
    <StepBox title={t('unable_complete_request')}>
      <Stack
        direction={{
          xs: 'column-reverse',
          sm: 'row',
        }}
        spacing={3}
        alignItems={{
          xs: 'center',
          sm: 'start',
        }}
        justifyContent="space-between"
      >
        <Typography>{t('verification_timed_out_description')}</Typography>
        <MySvgIcon name="timeout" width="123" height="129" />
      </Stack>
      <Button variant="contained" onClick={() => setFlow(toFlow)}>
        {t('back_to_security_verification')}
      </Button>
    </StepBox>
  );
};
